import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/permintaan-komponen-darah`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function find(id: number) {
  const response = await http
    .getData(`/permintaan-komponen-darah/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function create(data: any) {
  const response = await http
    .postData("/permintaan-komponen-darah", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/permintaan-komponen-darah/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/permintaan-komponen-darah/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function sign(id: number, data: { password: string }) {
  const response = await http
    .postData(`/permintaan-komponen-darah/${id}/sign`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function updateUtd(id: number, data: any) {
  const response = await http
    .putData(`/permintaan-komponen-darah/${id}/utd`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/permintaan-komponen-darah/${id}/pdf`, "_blank");
}

function printLabel(id: number, jumlah: number) {
  window.open(`${http.getAPI()}/permintaan-komponen-darah/${id}/label?jumlah=${jumlah}`, "_blank");
}

export default {
  getByRegister,
  find,
  create,
  update,
  destroy,
  sign,
  updateUtd,
  printPdf,
  printLabel
};
